import {
  IconBuildingFactory2,
  IconCircleCheck,
  IconLayersSubtract,
  IconRecycle,
} from "@tabler/icons-react";
import OrbitingCircles from "./ui/OrbitingCircles";

export function OrbitingCirclesDemo() {
  return (
    <div className="relative flex h-[500px] w-full flex-col items-center justify-center overflow-hidden rounded-lg border bg-white md:shadow-xl">
      <span className="font-semibold">$$</span>

      {/* Inner Circles */}
      <OrbitingCircles
        className="size-[25px] border-none bg-transparent"
        duration={20}
        delay={20}
        radius={40}
      >
        <IconRecycle />
      </OrbitingCircles>
      <OrbitingCircles
        className="size-[20px] border-none bg-transparent"
        duration={20}
        delay={10}
        radius={40}
      >
        <IconLayersSubtract />
      </OrbitingCircles>

      {/* Outer Circles (reverse) */}
      <OrbitingCircles
        className="size-[20px] border-none bg-transparent"
        radius={70}
        duration={20}
        reverse
      >
        <IconBuildingFactory2 />
      </OrbitingCircles>
      <OrbitingCircles
        className="size-[20px] border-none bg-transparent"
        radius={70}
        duration={20}
        delay={20}
        reverse
      >
        <IconCircleCheck />
      </OrbitingCircles>
    </div>
  );
}
